import { AvailableSectionsInterface } from 'modules/header/types/available-sections-interface'
import {
  CommunityEventTypes,
  UserEventTypes,
} from 'modules/profile/notifications/constants/notification-settings-const'
import { NotificationSettingApiInterface } from 'modules/profile/notifications/types/notification-settings-interface'

export const getAvailableSettings = (
  settings: NotificationSettingApiInterface,
  availableSections: AvailableSectionsInterface,
) => {
  let availableSettings = settings

  if (!availableSections.communities) {
    availableSettings = availableSettings.filter(
      setting => !CommunityEventTypes.includes(setting.eventType),
    )
  }

  return availableSettings.filter(setting => UserEventTypes.includes(setting.eventType))
}
